import { ROLE_TYPE } from '../constants';

export const RECOM_EXP_CONSOLE_HOST =
  process.env.REACT_APP_RECOM_EXP_CONSOLE_HOST;

export const ACTION_TYPE = {
  DELETE: 'delete',
  SUBMIT: 'submit',
  APPROVE: 'approve',
  REJECT: 'reject',
  ACTIVATE: 'activate',
  EDIT: 'edit',
  ARCHIVE: 'archive',
  PAUSE: 'pause',
  CREATE: 'create',
  REPLICATE: 'replicate',
  CLONE: 'clone',
  DISCARD: 'discard',
  COMPLETE: 'complete',
  UPLOAD: 'upload',
  UPDATE: 'update',
  DISCARD_ALL: 'discard all',
  ENABLE: 'enable',
  DISABLE: 'disable',
  CANCEL: 'cancel',
  SYNC: 'sync',
  HISTORY: 'history',
  PROMOTE: 'promote',
  WITHDRAW: 'withdraw',
  UNWITHDRAW: 'unwithdraw',
  PREVIEW: 'preview',
};
export const ACTION_TYPE_MSG = {
  [ACTION_TYPE.UPDATE]: 'updated',
  [ACTION_TYPE.SUBMIT]: 'submited',
  [ACTION_TYPE.APPROVE]: 'approved',
  [ACTION_TYPE.REJECT]: 'rejected',
  [ACTION_TYPE.DELETE]: 'deleted',
  [ACTION_TYPE.ACTIVATE]: 'activated',
  [ACTION_TYPE.EDIT]: 'edited',
  [ACTION_TYPE.ARCHIVE]: 'archived',
  [ACTION_TYPE.PAUSE]: 'paused',
  [ACTION_TYPE.CREATE]: 'created',
  [ACTION_TYPE.REPLICATE]: 'replicated',
  [ACTION_TYPE.CLONE]: 'cloned',
  [ACTION_TYPE.DISCARD]: 'discarded',
  [ACTION_TYPE.UPLOAD]: 'uploaded',
  [ACTION_TYPE.COMPLETE]: 'completed',
  [ACTION_TYPE.DISCARD_ALL]: 'discarded',
  [ACTION_TYPE.ENABLE]: 'enabled',
  [ACTION_TYPE.DISABLE]: 'disabled',
  [ACTION_TYPE.SYNC]: 'sync',
  [ACTION_TYPE.PROMOTE]: 'promoted',
  [ACTION_TYPE.WITHDRAW]: 'withdraw',
};
export const STATUS_TYPE = {
  ACTIVE: 'active',
  ACTIVE_RUNNING: 'active_running',
  ACTIVE_NOT_STARTED: 'active_not_started',
  DRAFT: 'draft',
  PENDING: 'pending',
  PENDING_APPROVAL: 'pending_approval',
  COMPLETED: 'completed',
  PAUSED: 'paused',
  APPROVED: 'approved',
  WITHDRAW: 'withdraw',
};
export const PRESCRIBER_STATUS_TYPE = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  COMPLETED: 'COMPLETED',
  PAUSED: 'PAUSED',
  APPROVED: 'APPROVED',
  WITHDRAW: 'WITHDRAW',
};
export const PRESCRIBER_NOTIFICATION_DELIVER_STATUS_TYPE = {
  PUSHING: 'PUSHING',
  STOP: 'STOP',
};
export const PRESCRIBER_SCENARIO_TYPE = {
  NO_DEVICE: 'NO_DEVICE',
  TIME_DEVICE: 'TIME_DEVICE',
  DEVICE_NOTIFY: 'DEVICE_NOTIFY',
  DEVICE_DEVICE: 'DEVICE_DEVICE',
  TIME_DEVICE_DEVICE: 'TIME_DEVICE_DEVICE',
  MEMBER_DEVICE: 'MEMBER_DEVICE',
};
export const PRESCRIBER_ACTION_TRANSITION = {
  [ACTION_TYPE.ACTIVATE]: PRESCRIBER_STATUS_TYPE.ACTIVE,
  [ACTION_TYPE.SUBMIT]: PRESCRIBER_STATUS_TYPE.PENDING_APPROVAL,
  [ACTION_TYPE.PAUSE]: PRESCRIBER_STATUS_TYPE.PAUSED,
  [ACTION_TYPE.COMPLETE]: PRESCRIBER_STATUS_TYPE.COMPLETED,
  [ACTION_TYPE.APPROVE]: PRESCRIBER_STATUS_TYPE.APPROVED,
  [ACTION_TYPE.WITHDRAW]: PRESCRIBER_STATUS_TYPE.WITHDRAW,
};
export const PRESCRIBER_ACTION_TRANSITION_PUSH_RECOM = {
  [ACTION_TYPE.ACTIVATE]: PRESCRIBER_STATUS_TYPE.ACTIVE,
  [ACTION_TYPE.SUBMIT]: PRESCRIBER_STATUS_TYPE.PENDING,
  [ACTION_TYPE.PAUSE]: PRESCRIBER_STATUS_TYPE.PAUSED,
  [ACTION_TYPE.COMPLETE]: PRESCRIBER_STATUS_TYPE.COMPLETED,
  [ACTION_TYPE.APPROVE]: PRESCRIBER_STATUS_TYPE.APPROVED,
  [ACTION_TYPE.WITHDRAW]: PRESCRIBER_STATUS_TYPE.WITHDRAW,
};
export const PRIORITY_OPT = [
  { label: '1 (Highest)', value: 1 },
  { label: '2', value: 2 },
  { label: '3 (Default)', value: 3 },
  { label: '4', value: 4 },
  { label: '5 (Lowest)', value: 5 },
];
export const DATE_STR_FORMAT = 'DD/MM/YYYY HH:mm';
export const CAMPAIGN_JSON_FILENAME = 'campaigns.json';
export const NOTIFICATION_JSON_FILENAME = 'notifications.json';

export const MENU_STEPS = {
  TO_STRING: ['campaignForm', 'recommendationForm'], // 'ABTestingForm'],
  TO_INT: {
    campaignForm: 0,
    recommendationForm: 1,
    // ABTestingForm: 2,
  },
};

export const MENU_STEPS_NEW = {
  TO_STRING: ['categoryForm', 'presetForm'],
  TO_INT: {
    categoryForm: 0,
    presetForm: 1,
  },
};

export const CONSTANTS_MENU_STEPS = {
  TO_INT: {
    campaignForm: 0,
    recommendationForm: 1,
    detailForm: 0,
    conditionForm: 1,
    categoryForm: 0,
    presetForm: 1,
    lifeForm: 0,
    productForm: 1,
  },
};

export const PRESCRIBER_STATUS = {
  DRAFT: 'Draft',
  PENDING: 'Pending',
  PENDING_APPROVAL: 'Pending',
  APPROVED: 'Approved',
  ACTIVE: 'Active',
  PAUSED: 'Paused',
  COMPLETED: 'Completed',
};

export const PRESCRIBER_STATUS_MAPPING = {
  DRAFT: 'DRAFT',
  WITHDRAW: 'WITHDRAW',
  PENDING_APPROVAL: 'REQUESTED',
  APPROVED: 'APPROVED',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
};

export const SMARTTHINGS_TYPE = {
  IOS: 'IOS',
  ANDROID: 'Android',
  BOTH: 'Both',
};

export const OS_KEY_BY_VALUE: {
  [osKey: string]: string;
} = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  iOS: 'iOS',
  Android: 'Android',
  android: 'android',
  ios: 'ios',
  all: 'all',
};

export const TEST_DATA = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];
export const CUSTOM_CAMPAIGN = [
  { label: 'Provided by system', value: false },
  { label: 'Enter campaign ID', value: true },
];

export const parseCountlyCampaign = (recommendations: any) => {
  const ret = {
    action_type: 'Unknown',
    device_type: 'Unknown',
    template_type: 'Unknown',
  };
  if (recommendations && recommendations.length > 0) {
    let action_type: string[] = [];
    let device_type: string[] = [];
    let template_type: string[] = [];

    for (let idx = 0; idx < recommendations.length; idx++) {
      let recom = recommendations[idx];
      // console.log('countly os', recom, recom.targetOs);
      if (recom.targetOs && recom.targetOs.length > 0) {
        for (let i = 0; i < recom.targetOs.length; i++) {
          if (device_type.indexOf(recom.targetOs[i].osType.toUpperCase()) < 0) {
            device_type.push(recom.targetOs[i].osType.toUpperCase());
          }
        }
      } else {
        if (device_type.indexOf('ALL') < 0) {
          device_type.push('ALL');
        }
      }

      if (recom.actionType) {
        if (action_type.indexOf(recom.actionType) < 0) {
          action_type.push(recom.actionType);
        }
      }

      if (recom.template && recom.template.templateType) {
        if (template_type.indexOf(recom.template.templateType) < 0) {
          template_type.push(recom.template.templateType);
        }
      }
    }
    const str_action_type =
      action_type.length > 0 ? action_type.toString() : 'Unknown';
    const str_device_type =
      device_type.length > 0 ? device_type.toString() : 'Unknown';
    const str_template_type =
      template_type.length > 0 ? template_type.toString() : 'Unknown';
    ret.action_type = str_action_type;
    ret.device_type = str_device_type;
    ret.template_type = str_template_type;
  }
  return ret;
};

export const statusActionMapping = (
  status: string,
  action: string,
  menu: 'push-recommendations' | 'campaigns',
) => {
  switch (status) {
    // case STATUS_TYPE.ACTIVE:
    // case STATUS_TYPE.ACTIVE_RUNNING:
    case STATUS_TYPE.ACTIVE_NOT_STARTED:
      switch (action) {
        case ACTION_TYPE.COMPLETE:
          return STATUS_TYPE.COMPLETED;
        case ACTION_TYPE.PAUSE:
          return STATUS_TYPE.PAUSED;
        default:
          return status;
      }
    case STATUS_TYPE.DRAFT:
      switch (action) {
        case ACTION_TYPE.SUBMIT:
          return menu === 'campaigns'
            ? STATUS_TYPE.PENDING_APPROVAL
            : STATUS_TYPE.PENDING;
        default:
          return status;
      }
    // case STATUS_TYPE.PENDING:
    case STATUS_TYPE.PENDING_APPROVAL:
      switch (action) {
        case ACTION_TYPE.REJECT:
          return STATUS_TYPE.DRAFT;
        case ACTION_TYPE.APPROVE:
          return STATUS_TYPE.APPROVED;
        default:
          return status;
      }
    case STATUS_TYPE.COMPLETED:
      switch (action) {
        case ACTION_TYPE.CLONE:
          return STATUS_TYPE.DRAFT;
        default:
          return status;
      }
    case STATUS_TYPE.PAUSED:
      switch (action) {
        case ACTION_TYPE.ACTIVATE:
          return STATUS_TYPE.ACTIVE;
        default:
          return status;
      }
    case STATUS_TYPE.APPROVED:
      switch (action) {
        case ACTION_TYPE.REJECT:
          return menu === 'campaigns'
            ? STATUS_TYPE.PENDING_APPROVAL
            : STATUS_TYPE.PENDING;
        case ACTION_TYPE.ACTIVATE:
          return STATUS_TYPE.ACTIVE;
        default:
          return status;
      }
    default:
      return status;
  }
};

export const ROLE_ACCESS = {
  STATUS_ACTIONS: {
    GLOBAL: {
      [ROLE_TYPE.OPERATION]: {
        [STATUS_TYPE.ACTIVE]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_RUNNING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.PENDING_APPROVAL]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
      },
      [ROLE_TYPE.GLOBAL_MANAGER]: {
        [STATUS_TYPE.ACTIVE]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_RUNNING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.PENDING_APPROVAL]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
      },
      [ROLE_TYPE.GLOBAL_GENERAL_ADMIN]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
        ],
      },
      [ROLE_TYPE.GLOBAL_SERVICE_ADMIN]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
        ],
      },
      [ROLE_TYPE.GLOBAL_VIEWER]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],
        [STATUS_TYPE.DRAFT]: [],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [],
        [STATUS_TYPE.PAUSED]: [],
        [STATUS_TYPE.APPROVED]: [],
      },
      [ROLE_TYPE.COUNTRY_MANAGER]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],
        [STATUS_TYPE.DRAFT]: [],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [],
        [STATUS_TYPE.PAUSED]: [],
        [STATUS_TYPE.APPROVED]: [],
      },
      [ROLE_TYPE.COUNTRY_GENERAL_ADMIN]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],
        [STATUS_TYPE.DRAFT]: [],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [],
        [STATUS_TYPE.PAUSED]: [],
        [STATUS_TYPE.APPROVED]: [],
      },
      [ROLE_TYPE.COUNTRY_SERVICE_ADMIN]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],
        [STATUS_TYPE.DRAFT]: [],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [],
        [STATUS_TYPE.PAUSED]: [],
        [STATUS_TYPE.APPROVED]: [],
      },
      [ROLE_TYPE.COUNTRY_VIEWER]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],
        [STATUS_TYPE.DRAFT]: [],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [],
        [STATUS_TYPE.PAUSED]: [],
        [STATUS_TYPE.APPROVED]: [],
      },
    },
    LOCAL: {
      [ROLE_TYPE.OPERATION]: {
        [STATUS_TYPE.ACTIVE]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_RUNNING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.PENDING_APPROVAL]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
      },
      [ROLE_TYPE.GLOBAL_MANAGER]: {
        [STATUS_TYPE.ACTIVE]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_RUNNING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.PENDING_APPROVAL]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.REJECT,
        ],
      },
      [ROLE_TYPE.GLOBAL_GENERAL_ADMIN]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
        ],
      },
      [ROLE_TYPE.GLOBAL_SERVICE_ADMIN]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
        ],
      },
      [ROLE_TYPE.GLOBAL_VIEWER]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],
        [STATUS_TYPE.DRAFT]: [],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [],
        [STATUS_TYPE.PAUSED]: [],
        [STATUS_TYPE.APPROVED]: [],
      },
      [ROLE_TYPE.COUNTRY_MANAGER]: {
        [STATUS_TYPE.ACTIVE]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_RUNNING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.COMPLETE,
          ACTION_TYPE.PAUSE,
        ],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.PENDING_APPROVAL]: [
          ACTION_TYPE.CLONE,
          ACTION_TYPE.APPROVE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.ACTIVATE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.REJECT,
        ],
      },
      [ROLE_TYPE.COUNTRY_GENERAL_ADMIN]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
        ],
      },
      [ROLE_TYPE.COUNTRY_SERVICE_ADMIN]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],

        [STATUS_TYPE.WITHDRAW]: [ACTION_TYPE.CLONE, ACTION_TYPE.UNWITHDRAW],
        [STATUS_TYPE.DRAFT]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.SUBMIT,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [ACTION_TYPE.CLONE],
        [STATUS_TYPE.PAUSED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
          ACTION_TYPE.DELETE,
        ],
        [STATUS_TYPE.APPROVED]: [
          ACTION_TYPE.EDIT,
          ACTION_TYPE.CLONE,
          ACTION_TYPE.WITHDRAW,
        ],
      },
      [ROLE_TYPE.COUNTRY_VIEWER]: {
        [STATUS_TYPE.ACTIVE]: [],
        [STATUS_TYPE.ACTIVE_RUNNING]: [],
        [STATUS_TYPE.ACTIVE_NOT_STARTED]: [],
        [STATUS_TYPE.DRAFT]: [],
        [STATUS_TYPE.PENDING]: [],
        [STATUS_TYPE.PENDING_APPROVAL]: [],
        [STATUS_TYPE.COMPLETED]: [],
        [STATUS_TYPE.PAUSED]: [],
        [STATUS_TYPE.APPROVED]: [],
      },
    },
  },
};

export const SPECIAL_LOCALE = {
  'b+s+latn': 'b+sr+latn',
  // 'b+sr+latn': 'b+sr+Latn',
  'b+-+LATN': 'b+sr+latn',
  'sr-34': 'sr-v34',
  sr_34: 'sr_v34',
  'sr-Cyrl-RS': 'sr-v34',
  'sr-Latn-RS': 'b+sr+latn',
};

export const MAPPING_SERBIAN_NON_DID = {
  'sr-v34': 'sr-Cyrl-RS',
  'b+sr+latn': 'sr-Latn-RS',
};

export const CONTENT_TYPE = [
  { label: 'Regular', value: false },
  { label: 'Dynamic', value: true },
];
export const SMARTTHINGS_OS_TYPE = [
  { label: 'iOS', value: SMARTTHINGS_TYPE.IOS },
  { label: 'Android', value: SMARTTHINGS_TYPE.ANDROID },
  { label: 'iOS & Android', value: SMARTTHINGS_TYPE.BOTH },
];

export const RECOMMENDATION_CONTENT_TYPE_KEY_BY_VALUE = [
  {
    value: 'REGULAR',
    label: 'Regular',
  },
  {
    value: 'REGULAR_WITH_INSTANT_VIEW',
    label: 'Regular With Instant View',
  },
  {
    value: 'DYNAMIC',
    label: 'Dynamic',
  },
];
export const RECOMMENDATION_ENTRY_TYPE_KEY_BY_VALUE = [
  {
    value: 'makeTranslations',
    label: 'Make translations',
  },
  {
    value: 'useDID',
    label: 'Use available DID',
  },
  {
    value: 'importFile',
    label: 'Import file for bulk upload',
  },
];
export const RECOMMENDATION_ENTRY_TYPE_KEY = {
  USE_DID: 'useDID',
  MAKE_TRANSLATIONS: 'makeTranslations',
  IMPORT_FILE: 'importFile',
};
export const RECOMMENDATION_CONTENT_TYPE_KEY = {
  REGULAR: 'REGULAR',
  DYNAMIC: 'DYNAMIC',
  REGULAR_WITH_INSTANT_VIEW: 'REGULAR_WITH_INSTANT_VIEW',
};
export const RECOMMENDATION_DYNAMIC_TYPE_KEY_BY_VALUE = [
  // {
  //   value: 'PERSONALIZED_VARIABLE',
  //   label: 'Personalized Variable',
  // },
  {
    value: 'PERSONALIZED_VARIABLE_IN_PARAM',
    label: 'Personalized Variable In Param',
  },
  // {
  //   value: 'PERSONALIZED_EXPLORE_STORY',
  //   label: 'Personalized Explore Story',
  // },
];

export const PULL_RECOMMENDATION_DYNAMIC_TYPE_KEY_BY_VALUE = [
  {
    value: 'PERSONALIZED_VARIABLE',
    label: 'Personalized Variable',
  },
  {
    value: 'PERSONALIZED_VARIABLE_IN_PARAM',
    label: 'Personalized Variable In Param',
  },
  {
    value: 'PERSONALIZED_EXPLORE_STORY',
    label: 'Personalized Explore Story',
  },
];

export const RECOMMENDATION_DYNAMIC_TYPE_KEY = {
  PERSONALIZED_VARIABLE_IN_PARAM: 'PERSONALIZED_VARIABLE_IN_PARAM',
  PERSONALIZED_VARIABLE: 'PERSONALIZED_VARIABLE',
  PERSONALIZED_EXPLORE_STORY: 'PERSONALIZED_EXPLORE_STORY',
};
